import clsx from "clsx";

import { Icon } from "../Icon";
import { IconsType } from "../Icon/utils";

export default function CardPill({
  className,
  icon,
  text,
}: {
  className?: string;
  icon?: IconsType;
  text: string;
}) {
  return (
    <p className={clsx("text-[10px] px-1 rounded-full text-white", className)}>
      {icon && <Icon name={icon} className="!h-[10px] mr-1 text-black" />}
      {text}
    </p>
  );
}
